export default {
    addNum(state) {
        state.count++
    }
}


// WEBPACK FOOTER //
// ./src/vuex/mutations/user.js